import { AfterViewInit, Component, ViewChild } from '@angular/core';
import { Router, RouterOutlet } from '@angular/router';
import { SpinnerComponent } from "./core/components/spinner/spinner.component";
import { HTTP_INTERCEPTORS } from '@angular/common/http';
import { LoaderInterceptor } from './core/interceptors/loader.interceptor';
import { ToastComponent } from "./shared/components/toast/toast.component";
import { ToastService } from './shared/services/toast/toast.service';
import { environment } from '../environments/environment';

@Component({
  selector: 'app-root',
  standalone:true,
  imports: [RouterOutlet, SpinnerComponent, ToastComponent],
  providers: [
    {
      provide: HTTP_INTERCEPTORS,
      useClass: LoaderInterceptor,
      multi: true
    }
  ],
  templateUrl: './app.component.html',
  styleUrl: './app.component.scss'
})
export class AppComponent implements AfterViewInit {
  @ViewChild(ToastComponent) toastComponent!: ToastComponent;
  @ViewChild(SpinnerComponent) spinnerComponent?: SpinnerComponent;
  title = 'portal-vivest-center';

  constructor(
    private toastService: ToastService   
  ) { 
    console.log(environment.ambiente);
  }
  ngAfterViewInit(): void {
    this.toastService.setToastComponent(this.toastComponent);
  }
}
